import {
  SET_MESSAGE,
  SET_USER,
  SET_STATUS,
  LOGOUT,
  GET_MY_FACILITIES,
} from "./types";

import AuthService from "../services/auth.service";

export const register = (data) => (dispatch) => {
  return AuthService.register(data).then(
    (response) => {
      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const login = (username, password) => (dispatch) => {
  return AuthService.login(username, password).then(
    (response) => {
      const { data } = response;
      dispatch({
        type: SET_USER,
        payload: { user: data },
      });

      return Promise.resolve();
    },
    (error) => {
      // console.log("AuthService error", error);

      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const logout = () => (dispatch) => {
  AuthService.logout();
  dispatch({
    type: LOGOUT,
  });
};

export const getCurrentUser = () => (dispatch) => {
  return AuthService.getCurrentUser()
    .then((response) => {
      const { data } = response;
      dispatch({
        type: SET_USER,
        payload: { user: data },
      });
    })
    .catch((error) => {
      dispatch({
        type: SET_STATUS,
      });
    });
};

export const getUser = (userId) => (dispatch) => {
  return AuthService.getUser(userId).then((data) => {
    const { data: userData } = data;
    const { facilities: myfacilities } = userData;
    dispatch({
      type: GET_MY_FACILITIES,
      payload: { myfacilities },
    });
  });
};
